import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { MaterialRequestDetailModal } from '@/components/manufacturing/MaterialRequestDetailModal';
import ProcurementAttachmentsCard from '@/components/procurement/ProcurementAttachmentsCard';
import { DOCUMENT_ENTITY_TYPE_MATERIAL_REQUEST } from '@/constants/document-entity-types';

const MaterialRequestDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <div style={{ padding: 24 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/scm/inventory/material-requests')}>
          Back to Material Requests
        </Button>
      </div>
    );
  }

  return (
    <>
      <div style={{ padding: '16px 24px 0' }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/scm/inventory/material-requests')}>
          Back to Material Requests
        </Button>
      </div>

      <MaterialRequestDetailModal
        visible
        renderAsPage
        materialRequestId={id}
        onClose={() => navigate('/scm/inventory/material-requests')}
      />

      <div style={{ padding: '0 24px 24px' }}>
        <ProcurementAttachmentsCard
          entityType={DOCUMENT_ENTITY_TYPE_MATERIAL_REQUEST}
          entityId={id}
          queryKeyPrefix={['documents', 'material-request']}
        />
      </div>
    </>
  );
};

export default MaterialRequestDetailPage;
